import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from '../firebase';

export const storageService = {
  // Upload user avatar
  async uploadAvatar(userId, file) {
    try {
      // Create a reference with timestamp to avoid conflicts
      const timestamp = Date.now();
      const avatarRef = ref(storage, `avatars/${userId}/${timestamp}_${file.name}`);
      
      // Upload the file
      const snapshot = await uploadBytes(avatarRef, file);
      
      // Get the download URL
      const downloadURL = await getDownloadURL(snapshot.ref);
      
      return {
        url: downloadURL,
        path: snapshot.ref.fullPath
      };
    } catch (error) {
      console.error('Error uploading avatar:', error);
      throw new Error(error.message);
    }
  },

  // Delete user avatar
  async deleteAvatar(userId, filePath) {
    try {
      // Skip deletion if the path is a URL (e.g., from Google profile)
      if (!filePath || filePath.startsWith('http')) {
        return;
      }
      
      const avatarRef = ref(storage, filePath);
      await deleteObject(avatarRef);
    } catch (error) {
      // Ignore if file doesn't exist
      if (error.code !== 'storage/object-not-found') {
        console.error('Error deleting avatar:', error);
        throw new Error(error.message);
      }
    }
  },

  // Update user avatar (handles deletion of old avatar)
  async updateAvatar(userId, file, oldFilePath) {
    try {
      // Only attempt to delete if it's a Firebase Storage path
      if (oldFilePath && !oldFilePath.startsWith('http')) {
        await this.deleteAvatar(userId, oldFilePath);
      }
      
      // Upload new avatar
      return await this.uploadAvatar(userId, file);
    } catch (error) {
      console.error('Error updating avatar:', error);
      throw new Error(error.message);
    }
  }
}; 